const Cloudy = (props) => (
  <svg
    width="37"
    height="38"
    viewBox="0 0 37 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.875 19C10.875 16.6514 11.5715 14.3554 12.8763 12.4026C14.1811 10.4498 16.0358 8.92773 18.2056 8.02894C20.3755 7.13015 22.7632 6.89498 25.0667 7.35318C27.3702 7.81138 29.4861 8.94236 31.1469 10.6031C32.8076 12.2639 33.9386 14.3798 34.3968 16.6833C34.855 18.9868 34.6199 21.3745 33.7211 23.5444C32.8223 25.7142 31.3002 27.5689 29.3474 28.8737C27.3946 30.1785 25.0987 30.875 22.75 30.875H9.6875C8.50867 30.8739 7.34356 30.622 6.26951 30.1361C5.19546 29.6503 4.23703 28.9415 3.45785 28.0569C2.67866 27.1723 2.09654 26.1321 1.75012 25.0053C1.4037 23.8785 1.3009 22.6909 1.44855 21.5214C1.5962 20.3518 1.99092 19.227 2.60651 18.2217C3.2221 17.2164 4.04448 16.3535 5.01906 15.6903C5.99365 15.0271 7.09815 14.5787 8.25925 14.375C9.42035 14.1713 10.6115 14.2169 11.7536 14.5088"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Cloudy
